import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-vrjmof.svg'
import _imports_1 from '@/assets/images/2024-prologue/logo-date_pre.svg'
import _imports_2 from '@/assets/images/banner_livestream.png'
import _imports_3 from '@/assets/images/logo-vrchat_ex.png'
import _imports_4 from '@/assets/images/logo-resonite.svg'
import _imports_5 from '@/assets/images/2024-prologue/title-access.svg'
import _imports_6 from '@/assets/images/2024-prologue/title-timetable.svg'
import _imports_7 from '@/assets/images/2024-prologue/image-schedule.jpg'
import _imports_8 from '@/assets/images/2024-prologue/title-map.svg'
import _imports_9 from '@/assets/images/floorMap.png'
import _imports_10 from '@/assets/images/2024-prologue/title-notice.svg'
import _imports_11 from '@/assets/images/user-circle-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-4dcb11e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "VR JMoF",
    class: "main"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Prologue Event date: 2023.10.21",
    class: "sub"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "main-section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contents banner-link-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
      /*#__PURE__*/_createElementVNode("a", {
        target: "_blank",
        href: "https://www.twitch.tv/vr_jmof/"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          alt: "公式動画配信 / Official Livestream",
          width: "300"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents main-catch" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 今年もVR JMoFのプレイベントが開催決定！"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" VRケモノコンベンション“VR JMoF 2024”は、2024年1月に愛知県・豊橋で開催されるリアルケモノコンベンション“JMoF 2024”との同時開催を予定しています。 ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" それに先駆け、VRやJMoFについてみなさんに紹介する機会としてのプレイベント“VR JMoF Prologue”を開催します！"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" なんと今回はVRChatだけでなく、公開されたばかりのVRプラットフォーム “Resonite”での企画も用意しています！ ")
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-logo" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "logo-link",
          href: "https://hello.vrchat.com/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            class: "image",
            src: _imports_3,
            alt: "VRChat"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "logo-link",
          href: "https://resonite.com/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            class: "image",
            src: _imports_4,
            alt: "resonite"
          })
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents" }, [
    /*#__PURE__*/_createElementVNode("h2", {
      class: "main-heading",
      id: "access"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: "参加方法"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" 「 "),
        /*#__PURE__*/_createElementVNode("a", { href: "/access" }, " アクセス方法"),
        /*#__PURE__*/_createTextVNode(" 」 ページをご覧になったうえで、開催期間中にVR JMoFワールドにJoin（入場）してください。 ")
      ]),
      /*#__PURE__*/_createElementVNode("h3", null, "企画への参加方法"),
      /*#__PURE__*/_createElementVNode("dl", { class: "access-box" }, [
        /*#__PURE__*/_createElementVNode("dt", { class: "title" }, "VRChat："),
        /*#__PURE__*/_createElementVNode("dd", null, " 企画を開催するインスタンスは、事前に公式動画配信で告知されます。参加を希望される方は、告知されたインスタンスへお越しください。 ")
      ]),
      /*#__PURE__*/_createElementVNode("dl", { class: "access-box" }, [
        /*#__PURE__*/_createElementVNode("dt", { class: "title" }, "Resonite："),
        /*#__PURE__*/_createElementVNode("dd", null, " 企画開始時刻までに公式セッションにJoinし、運営スタッフにお声かけください。 ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents" }, [
    /*#__PURE__*/_createElementVNode("h2", {
      class: "main-heading",
      id: "avatar_poster"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        alt: "タイムテーブル"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "body-image" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "dialog-image",
        src: _imports_7,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents" }, [
    /*#__PURE__*/_createElementVNode("h2", {
      class: "main-heading",
      id: "avatar_poster"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_8,
        alt: "会場マップ"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "body-image" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "dialog-image",
        src: _imports_9,
        alt: ""
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contents" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "main-heading" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_10,
        alt: "注意事項"
      })
    ]),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" 本イベントへの参加にあたっては、"),
        /*#__PURE__*/_createElementVNode("a", { href: "https://vr.jmof.jp/terms" }, "VR JMoFの参加規約"),
        /*#__PURE__*/_createTextVNode("、およびそれぞれのVRプラットフォームの利用規約やガイドラインを遵守してください。 ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, " 本イベントは、プレイベントという性質上、企画開催や動画配信の方法などについて試験的な運用を行うことがあります。そのため、企画や配信が中断されたり、うまく視聴できなかったりする場合も想定されます。ご不便をおかけしますが、なにとぞご承知おきください。 "),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" 本イベントは日本語で進行します。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("Note: Many of the programs will take place in the Japanese language. ")
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "event-link" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image",
    src: _imports_11
  }),
  /*#__PURE__*/_createTextVNode("ワールドに入場する ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sub" }, "インスタンス一覧ページへ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createBlock(_component_TheDetailPageBody, { class: "page-prologue" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "link",
          to: "/access/instances"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}